define(['jquery'], function ($) {
    $.ajaxQ = (function () {
        var id = 0, Q = {};

        $(document).ajaxSend(function (e, jqx) {
            jqx._id = ++id;
            Q[jqx._id] = jqx;
        });

        $(document).ajaxComplete(function (e, jqx) {
            delete Q[jqx._id];
        });

        return {
            abortAll: function () {
                var r = [];
                $.each(Q, function (i, jqx) {
                    r.push(jqx._id);
                    jqx.abort();
                });
                return r;
            }
        };
    })();
});